import { FilterOptionLicense as FilterOptionLicenseMetric } from 'src/models/FilterMetric';
import { FilterOption as FilterOptionDrawer } from 'src/models/Filter';

// contast
import { DROPDOWN_CHECKBOX_TYPE } from 'src/models/Filter/filterData';

const metricFilterLicenseToDrawerFilterLicense = (
  onAddFilterDrawer: (filterOptionDrawer: FilterOptionDrawer) => void,
  filterOptionLicenseMetric: FilterOptionLicenseMetric,
): void => {
  if (filterOptionLicenseMetric.queryKey === '') {
    return;
  }
  onAddFilterDrawer({
    id: filterOptionLicenseMetric.queryKey,
    categoryId: 'license',
    description: filterOptionLicenseMetric.description,
    queryKey: filterOptionLicenseMetric.queryKey,
    componentType: DROPDOWN_CHECKBOX_TYPE,
  });
};

export default metricFilterLicenseToDrawerFilterLicense;
